import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";
import { minHeightDvh } from "@/utils/viewport";

export default function MarketingLayout() {
  return (
    <Box sx={{ ...minHeightDvh, display: "flex", flexDirection: "column" }}>
      <Box
        component="a"
        href="#main-content"
        sx={{
          position: "absolute",
          left: 8,
          top: -40,
          zIndex: 9999,
          px: 2,
          py: 1,
          bgcolor: "background.paper",
          color: "primary.main",
          borderRadius: "4px",
          textDecoration: "none",
          fontWeight: 600,
          "&:focus": {
            top: 8,
            outline: "2px solid",
            outlineColor: "primary.main",
            outlineOffset: 2,
          },
        }}
      >
        Skip to content
      </Box>
      <MarketingNav />
      <Box id="main-content" component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <MarketingFooter />
    </Box>
  );
}
